export default __webpack_public_path__ + "logo-section-v2.png";